import React from 'react';
import {
  Box,
  Text,
  VStack,
  HStack,
  IconButton,
  Flex,
  Avatar,
  useColorModeValue,
} from '@chakra-ui/react';
import { EditIcon, DeleteIcon } from '@chakra-ui/icons';

const CustomerList = ({ customers, onEdit, onDelete }) => {
  // Color mode values for modern styling
  const cardBg = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const textColor = useColorModeValue('gray.700', 'gray.200');
  const subtleTextColor = useColorModeValue('gray.600', 'gray.400');
  const shadowColor = useColorModeValue('rgba(0, 0, 0, 0.1)', 'rgba(0, 0, 0, 0.3)');
  return (
    <>
      {customers.map((customer) => (
        <Box
          key={customer.id}
          bg={cardBg}
          borderRadius="xl"
          border="1px solid"
          borderColor={borderColor}
          p={6}
          boxShadow={`0 10px 15px -3px ${shadowColor}`}
          position="relative"
          overflow="hidden"
          transition="all 0.3s ease"
          _hover={{ 
            transform: "translateY(-4px)",
            boxShadow: `0 20px 25px -5px ${shadowColor}, 0 10px 10px -5px ${shadowColor}`,
          }}
        >
          {/* Gradient accent */}
          <Box
            position="absolute"
            top={0}
            left={0}
            right={0}
            height="4px"
            bg="linear-gradient(90deg, #667eea, #764ba2)"
          />
          
          <Flex justify="space-between" align="flex-start">
            <HStack spacing={4} align="flex-start" flex="1">
              <Avatar 
                name={customer.name} 
                size="lg"
                bg="linear-gradient(135deg, #667eea, #764ba2)"
                color="white"
              />
              <VStack align="flex-start" spacing={2} flex="1">
                <Text 
                  fontWeight="bold" 
                  fontSize="lg"
                  color={textColor}
                  noOfLines={1}
                >
                  👤 {customer.name || 'N/A'}
                </Text>
                <VStack align="flex-start" spacing={1}>
                  <Text fontSize="sm" color={subtleTextColor}>
                    📧 Email: {customer.email || 'N/A'}
                  </Text>
                  <Text fontSize="sm" color={subtleTextColor}>
                    📞 Телефон: {customer.phone_number || 'N/A'}
                  </Text>
                  <Text fontSize="sm" color={subtleTextColor}>
                    🏢 ЄДРПОУ: {customer.edrpou_code || 'N/A'}
                  </Text>
                  <Text fontSize="sm" color={subtleTextColor} noOfLines={1}>
                    📍 Адреса: {customer.address || 'N/A'}
                  </Text>
                  <Text fontSize="sm" color={subtleTextColor} noOfLines={1}>
                    🏦 Банк: {customer.bank_name || 'N/A'}
                  </Text>
                  <Text fontSize="sm" color={subtleTextColor}>
                    💳 Рахунок: {customer.bank_number || 'N/A'}
                  </Text>
                </VStack>
                <VStack align="flex-start" spacing={1} pt={2}>
                  <Text fontSize="xs" color={subtleTextColor}>
                    📅 Створено: {customer.created_at || 'N/A'}
                  </Text>
                  <Text fontSize="xs" color={subtleTextColor}>
                    🔄 Оновлено: {customer.updated_at || 'N/A'}
                  </Text>
                </VStack>
              </VStack>
            </HStack>
            
            {/* Action buttons positioned at bottom right */}
            <VStack spacing={2} position="absolute" bottom={4} right={4}>
              <IconButton
                icon={<EditIcon />}
                size="sm"
                borderRadius="lg"
                bg="linear-gradient(135deg, #4facfe, #00f2fe)"
                color="white"
                boxShadow="0 4px 6px rgba(79, 172, 254, 0.3)"
                _hover={{
                  bg: "linear-gradient(135deg, #3d8bfe, #00d4ff)",
                  transform: "translateY(-1px)",
                  boxShadow: "0 6px 8px rgba(79, 172, 254, 0.4)",
                }}
                onClick={() => onEdit(customer)}
                aria-label="Edit Customer"
              />
              <IconButton
                icon={<DeleteIcon />}
                size="sm"
                borderRadius="lg"
                bg="linear-gradient(135deg, #f093fb, #f5576c)"
                color="white"
                boxShadow="0 4px 6px rgba(240, 147, 251, 0.3)"
                _hover={{
                  bg: "linear-gradient(135deg, #e084fc, #f4466b)",
                  transform: "translateY(-1px)",
                  boxShadow: "0 6px 8px rgba(240, 147, 251, 0.4)",
                }}
                onClick={() => onDelete(customer)}
                aria-label="Delete Customer"
              />
            </VStack>
          </Flex>
        </Box>
      ))}
    </>
  );
};

export default CustomerList;
